export const cn = (...classes) => classes.filter(Boolean).join(" ");

export const formatCurrency = (amount) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Number(amount) || 0);

export const formatDateTime = (value) => {
  if (!value) {
    return "-";
  }
  return new Intl.DateTimeFormat("en-IN", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
};

export const normalizePhone = (value) => (value || "").replace(/\D/g, "").slice(-10);

export const getSafeId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `dreameer-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const arrayFromCsv = (value) =>
  (value || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);

export const createAvatarDataUri = (name, background = "#059669", accent = "#f59e0b") => {
  const initials = (name || "Dreameer")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 240" role="img" aria-label="${name}">
      <defs>
        <linearGradient id="g" x1="0%" x2="100%" y1="0%" y2="100%">
          <stop offset="0%" stop-color="${background}" />
          <stop offset="100%" stop-color="${accent}" />
        </linearGradient>
      </defs>
      <rect width="320" height="240" rx="36" fill="#f8fafc" />
      <circle cx="160" cy="108" r="72" fill="url(#g)" opacity="0.98" />
      <path d="M76 212c16-40 50-60 84-60s68 20 84 60" fill="#e2e8f0" />
      <text x="160" y="128" text-anchor="middle" font-size="56" font-family="Space Grotesk, sans-serif" font-weight="700" fill="#ffffff">${initials}</text>
      <text x="160" y="208" text-anchor="middle" font-size="16" font-family="DM Sans, sans-serif" fill="#334155">${name}</text>
    </svg>`;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

const escapeCsv = (value) => {
  const stringValue = String(value ?? "");
  if (stringValue.includes(",") || stringValue.includes("\n") || stringValue.includes('"')) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

export const downloadCsv = (filename, rows) => {
  if (!rows || !rows.length) {
    return false;
  }

  const headers = Array.from(new Set(rows.flatMap((row) => Object.keys(row))));
  const csv = [
    headers.join(","),
    ...rows.map((row) => headers.map((header) => escapeCsv(row[header])).join(",")),
  ].join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return true;
};

export const createWhatsAppUrl = ({ tutorName, studentName, mobile, slot }) => {
  const message = `Hi Dreameer, I want a demo with ${tutorName}. Student: ${studentName}, Mobile: +91${mobile}, Slot: ${slot}`;
  return `https://wa.me/919507505612?text=${encodeURIComponent(message)}`;
};
